import { FormErrors } from "redux-form";

import { RegisterFormData } from "./RegisterPageForm";
import {
    required,
    equal,
    validEmail,
    validPassword,
} from "../../../util/validators";

const validateRegisterPageForm = (values: RegisterFormData) => {
    const errors: FormErrors<RegisterFormData> = {};
    if (!values.useTupas) {
        errors.username = required(values.username);
        errors.password = validPassword(values.password);
        errors.verifyPassword = equal(values.password, values.verifyPassword);
    }
    errors.phoneNumber = required(values.phoneNumber);
    errors.email = required(values.email);
    errors.email = validEmail(values.email);
    errors.acceptTerms = required(values.acceptTerms);

    return errors;
};

export default validateRegisterPageForm;



// WEBPACK FOOTER //
// ./src/views/register/components/RegisterPageFormValidator.ts